import React from 'react';
import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';
import { SidebarProvider } from '../contexts/SidebarContext';

function Layout() {
  return (
    <SidebarProvider>
      <div className="app-layout">
        <Navbar />
        <div className="app-layout__main">
          <Outlet />
        </div>
      </div>
    </SidebarProvider>
  );
}

export default Layout;
